import module from 'nominas/nomina/module.js'
import template from './template.html'

export class NominasNominaDispersionPagosImprimirComponent {
  $onChanges (changes) {
    if (changes.data) {
      this.data = this.data
        .filter((item) => item.id_metodo_pago === 2 && item.status_aprobado && item.status_pagado && item.cheque_numero)
      this.omitidos = changes.data.currentValue.length - this.data.length
    }
  }
}

module.component('nominasNominaDispersionPagosImprimir', {
  controller: NominasNominaDispersionPagosImprimirComponent,
  template,
  bindings: {
    idProyecto: '<',
    idNomina: '<',
    data: '<',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/dispersion/pagos/imprimir/component.js